import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { Collapsible, CollapsibleHeader, CollapsibleContent } from '@fiverr-private/disclosure';
import { Divider } from '@fiverr-private/layout_components';
import type { FAQItem } from '../../types';

type FAQCollapsibleItemProps = Readonly<FAQItem>;

export const FAQCollapsibleItem = ({ question, answer }: FAQCollapsibleItemProps) => (
    <Collapsible>
        <CollapsibleHeader>
            <Typography color="grey_1100" fontWeight="normal" fontSize="h_xs">
                {question}
            </Typography>
        </CollapsibleHeader>
        <CollapsibleContent>
            <Typography as="span" paddingBottom="4">
                {answer}
            </Typography>
        </CollapsibleContent>
        <Divider />
    </Collapsible>
);
